import Indicator, { IndicatorType } from '../types/Indicator'

const Low: Indicator = {
  type: IndicatorType.PRICE,
  value: 'low',
  label: 'Low',
  fields: ['low'],
}

export default Low
